import { connect } from 'react-redux'
import ServiceList from '../../components/services/list/ServiceList'
import { fetchServiceList, actionCreators } from '../../state/actions/services/index'
import { getServiceFetching, getServiceFetchingError, getServiceListColumns } from '../../state/reducers/services'
import { IServiceStateFilters, IStoreState } from '../../types/index'
import { fetchServicePrograms } from 'src/state/actions/service-program/service-program'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    items: Object.values(state.service.items),
    servicePrograms: state.serviceProgram.items || [],
    orgId: state.organizations.currentOrgId,
    columns: getServiceListColumns(state),
    type: ownProps.type,
    fetching: getServiceFetching(state),
    fetchingError: getServiceFetchingError(state),
    isArchive: state.service.metadata.archive,
    isRestore: state.service.metadata.restore,
    filters: state.service.filters,
    serviceListTotal: state.service.serviceListTotal
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: (params: IServiceStateFilters) => {
      if (params.type && params.organizationId) {
        dispatch(
          fetchServiceList(params.type, params.organizationId, params.orderBy, params.sort, params.take, params.skip)
        )
        return dispatch(fetchServicePrograms())
      }
    },
    fetchServicePrograms: () => {
      return dispatch(fetchServicePrograms())
    },
    showArchiveModal: (serviceId: string) => {
      dispatch(actionCreators.serviceArchiveModalShow(serviceId))
    },
    showRestoreModal: (serviceId: string) => {
      dispatch(actionCreators.serviceRestoreModalShow(serviceId))
    },
    updateServiceFilters: (params: IServiceStateFilters) => {
      return dispatch(actionCreators.updateServiceFilters(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceList)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceList.ts